module.exports = __webpack_public_path__ + "static/media/studio-etc8.a187cc9e.png";